import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.clients_api.memberships;


const api = setupAuthInterceptor(axios.create({
 baseURL: BASE_URL,
 headers: {
   'Content-Type': 'application/json',
 }
}));

// Create a new membership tier
export const createMembership = async (data: {
  local_id: number;
  membership_name: string;
  membership_description?: string;
  discount_percentage: number;
  is_default?: boolean;
  next_membership_id?: number;
  next_level_required_spent?: number;
}) => {
  return retryWithBackoff(() => api.post('/CreateMembership', data));
};

// Update an existing membership
export const updateMembership = async (
  membership_id: number,
  data: {
    membership_name?: string;
    membership_description?: string;
    discount_percentage?: number;
    is_default?: boolean;
    next_membership_id?: number;
    next_level_required_spent?: number;
  }
) => {
  return retryWithBackoff(() => api.put(`/UpdateMembership/${membership_id}`, data));
};

// Get all memberships for a specific local (hierarchical nested structure)
export const getMembershipsByLocalId = async (local_id: number) => {
  return retryWithBackoff(() => api.get(`/GetMembershipsByLocalId/${local_id}`));
};

// Get a single membership by ID
export const getMembershipById = async (membership_id: number) => {
  return retryWithBackoff(() => api.get(`/GetMembership/${membership_id}`));
};

// Delete a membership (cannot delete if clients are assigned to it)
export const deleteMembership = async (membership_id: number) => {
  return retryWithBackoff(() => api.delete(`/DeleteMembership/${membership_id}`));
};



